import React from "react";
import "../css/LandingPage.css";

export default function FeaturedActiveListings() {
  const go = (hash) => {
    // If you're not using react-router, this is perfect:
    window.location.href = `/listings${hash}`;
  };

  return (
    <div>
      <div className="reviews-toolbar properties-toolbar" style={{ paddingTop: 0 }}>
        <div>
          <h2 className="reviews-section-title" style={{ margin: 0 }}>
            My Portfolio
          </h2>
          <p
            style={{
              margin: "10px 0 0",
              color: "var(--text-on-dark)",
              textAlign: "center",
            }}
          >
            View my active listings, or check me out on Zillow!
          </p>
        </div>
      </div>

      <div className="properties-cta-row">
        <a className="btn primary" href="/listings#active">
          View My Portfolio
        </a>

        <a
          className="btn primary"
          href="https://www.zillow.com/profile/broscoehome"
          target="_blank"
          rel="noopener noreferrer"
        >
          View on Zillow
        </a>
      </div>

    </div>
  );
}
